var _this = this;

/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-23 17:00:58
 * @LastEditTime: 2020-11-25 15:01:34
 */

/*
@module biz.captcha
@description 基于腾讯防水墙的验证码机制，通过在ams管理端配置并结合ame后端校验进行身份校验和防刷
*/
import ams from '../common/ams';
import { isFunction } from '../common/base';
import loader from '../common/loader'; // appid - instance  验证码实例，按appid区分

var instancePool = {}; // appid - callback  验证码回调，按appid区分

var callbackPool = {};
var captcha = {
  // flowengine提交之前进行校验，判断是否要校验，如果需要校验则校验，如果不需要，则放行
  judgeCap: function judgeCap(iActivity, iFlowId, callback) {
    var self = this;
    self.getCapConfig(iActivity, iFlowId, function (config) {
      var iCap = config.iCap;

      if (iCap == 1) {
        // 需要每次都校验
        self.doCap(iActivity, iFlowId, callback);
      } else {
        // 不需要防刷
        callback();
      }
    });
  },
  // ame返回需要进行验证码校验，弹出验证码校验逻辑
  doCap: function doCap(iActivity, iFlowId, callback) {
    _this.getCapConfig(iActivity, iFlowId, function (config) {
      var sAppId = config.sAppId;
      this.getInstance(sAppId, function (instance) {
        // 设置callback
        callbackPool[sAppId] = callback;
        instance.show();
      });
    });
  },
  // 拿到对应流程的防刷配置
  getCapConfig: function getCapConfig(iActivity, iFlowId, callback) {
    ams.getActivity(iActivity, function (actdesc) {
      var sAppId = actdesc.capAppId;
      var iCap = actdesc.flows["f_".concat(iFlowId)].iCap;
      callback({
        sAppId: sAppId,
        iCap: iCap
      });
    });
  },
  // 获取防刷验证码实例
  getInstance: function getInstance(sAppId, callback) {
    if (instancePool[sAppId]) {
      callback(instancePool[sAppId]);
    } else {
      // 创建实例
      var doInstance = function doInstance(sAppId, callback) {
        instancePool[sAppId] = new window.TencentCaptcha(sAppId, function (res) {
          if (0 == res.ret) {
            // 前端验证通过
            var cb = callbackPool[res.appid];
            isFunction(cb) && cb(res);
          } else if (2 == res.ret) {// 用户主动关闭验证码
          }
        });
        callback(instancePool[sAppId]);
      };

      if ('function' === typeof TencentCaptcha) {
        doInstance(sAppId, callback);
      } else {
        loader.loadScript('https://ssl.captcha.qq.com/TCaptcha.js', function () {
          doInstance(sAppId, callback);
        });
      }
    }
  }
};
export default captcha;